import { render, staticRenderFns } from "./PromptMessage.vue?vue&type=template&id=e64face6&"
import script from "./PromptMessage.vue?vue&type=script&lang=js&"
export * from "./PromptMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports